import { FlightServiceModel, FlightServicesModel } from '@/lib/models/flight-service/types';
import {
  FlightServiceApiInterface,
  FlightServicesApiInterface,
  RouteCarriersApiV2Interface,
  RouteVehiclesApiV2Interface,
} from '@/types/api-types';
import { bitmaskToDays } from '@/utils/format/days-of-week';
import { generateId } from '@/utils/helpers';
import { isFreighterAircraft } from '@/utils/vehicle';

import { getFlightServiceFlightNumber } from './utils/get-flight-number';
import { parseTimeString } from './utils/parse-time-string';

export const transformFlightServices = (
  flightService: FlightServicesApiInterface,
  vehicles: RouteVehiclesApiV2Interface,
  carriers: RouteCarriersApiV2Interface,
): FlightServicesModel => {
  // Sort services by departure time
  const sortedServices = flightService.service.sort((a, b) => {
    const departureTimeA = parseTimeString(a.departureTime);
    const departureTimeB = parseTimeString(b.departureTime);
    return departureTimeA.getTime() - departureTimeB.getTime();
  });

  return {
    ...flightService,
    id: generateId(),
    service: sortedServices.map((service) => transformFlightService(service, vehicles, carriers)),
  };
};

const transformFlightService = (
  service: FlightServiceApiInterface,
  vehicles: RouteVehiclesApiV2Interface,
  carriers: RouteCarriersApiV2Interface,
): FlightServiceModel => {
  const vehicle = vehicles[service.vehicleId];

  return {
    ...service,
    id: generateId(),
    flightNumber: getFlightServiceFlightNumber(service, carriers),
    isFreightAircraft: isFreighterAircraft(vehicle),
    operatingDays: bitmaskToDays(service.days),
  };
};
